import { render } from "./tonglianPrecisionTube.vue?vue&type=template&id=8d4029e2&scoped=true"
import script from "./tonglianPrecisionTube.vue?vue&type=script&lang=js"
export * from "./tonglianPrecisionTube.vue?vue&type=script&lang=js"

import "./tonglianPrecisionTube.vue?vue&type=style&index=0&id=8d4029e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8d4029e2"

export default script